import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { SITE } from "../config/site";
import { useLead } from "../context/LeadContext";

const base =
  "group inline-flex items-center justify-center gap-2 px-7 py-4 text-[13px] font-bold tracking-[0.12em] uppercase transition-colors duration-300 select-none";

export const BookButton = ({ label = "Book Your Free Inspection", className = "", testid = "book-inspection-btn", light = false }) => {
  const { openModal } = useLead();
  return (
    <button
      data-testid={testid}
      onClick={() => openModal()}
      className={`${base} ${light ? "bg-ivory text-wine hover:bg-gold hover:text-charcoal" : "bg-wine text-ivory hover:bg-wine-light"} ${className}`}
    >
      {label}
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
    </button>
  );
};

export const CallButton = ({ className = "", testid = "call-now-btn", label = "Call Now", dark = false }) => (
  <a
    data-testid={testid}
    href={SITE.phoneHref}
    className={`${base} border ${dark ? "border-ivory/40 text-ivory hover:bg-ivory hover:text-wine" : "border-charcoal/30 text-charcoal hover:border-wine hover:text-wine"} ${className}`}
  >
    <Phone className="h-4 w-4" />
    {label}
  </a>
);

export const WhatsAppButton = ({ className = "", testid = "whatsapp-btn", label = "WhatsApp Us" }) => (
  <a
    data-testid={testid}
    href={SITE.whatsappHref}
    target="_blank"
    rel="noopener noreferrer"
    className={`${base} bg-[#1FA855] text-ivory hover:bg-[#23c05f] shadow-[0_0_22px_rgba(31,168,85,0.4)] ${className}`}
  >
    <MessageCircle className="h-4 w-4" />
    {label}
  </a>
);
